const historyItemTranslations = {
  emailMessage: {
    label: "Emails",
  },
  lawyer: {
    label: "Anwalt",
  },
  fax: {
    label: "Faxe",
  },
  accountManager: {
    label: "Zuständiger",
  },
  assignedUserChange: {
    label: "Zuständiger Benutzer",
  },
  beaMessage: {
    label: "beA Nachrichten",
  },
  paidTask: {
    label: "Ausschreibungen",
  },
  passwordReset: {
    label: "Passwort zurückgesetzt",
  },
  mailPause: {
    label: "Emails und Nachrichten pausiert",
  },
  activity: {
    label: "Aktivitäten",
  },
  note: {
    label: "Notizen",
  },
  mediaObject: {
    label: "Dokumente",
  },
  mediaObjectDelete: {
    label: "Verlaufseintrag für gelöschte Datei",
  },
  customerRegistration: {
    label: "Registrierung",
  },
  caseCreated: {
    label: "Fall erstellt",
  },
  entityStatusChange: {
    label: "Statusänderung",
  },
  entityStatusChangeByCustomerPrevented: {
    label: "Statusänderung verhindert",
  },
  entityDataChange: {
    label: "Änderung",
  },
  customerDataChange: {
    label: "Änderung",
  },
  caseStatusChange: {
    label: "Zustand geändert",
    lost: {
      label: "Fall verloren",
      lostCategory: {
        noResponse: "Kein Kontakt möglich / Keine Rückmeldung",
        caseChange: "Wechsel auf anderen Fall",
        customerRefusal: "Ablehnung weiteres Vorgehen durch Kunde (ohne Begründung)",
        insuranceRefusal: "Kostenablehnung durch RSV",
        noInsurance: "Schlechtes Kosten-Nutzen-Verhältnis (z.B. durch fehlende RSV)",
        noLegalBasis: "Rechtliches Vorgehen nicht möglich / Kein Case",
        localLawyer: "Lokaler Anwalt",
        nonPayment: "Verloren wegen Nichtzahlung",
        noCorrespondingProduct: "Kein Legalbird-Rechtsgebiet",
        other: "Sonstiges",
      },
    },
    won: {
      label: "Fall gewonnen",
    },
    open: {
      label: "Fall wieder geöffnet",
    },
    inactive: {
      label: "Fall inaktiv",
    },
  },
  invoiceTypeIdentifierChange: {
    label: "Änderung",
  },
  invoiceDelete: {
    label: "Buchungseintrag",
  },
  invoiceReassign: {
    label: "Neuzuweisung Buchungseintrag",
  },
  client: "Mandantschaft",
  inquiry: {
    label: "Inquiry",
    link: {
      identifier: {
        label: "Identifier",
        unknown: {
          label: "Anfrage mit verlinkter Seite",
        },
        nextInstanceDecisionInquiry: {
          label: "Anfrage Entscheidung Berufungsverfahren",
        },
        customerFeedbackInquiry: {
          label: "Anfrage weiteres Vorgehen",
        },
        administrativeDecisionFeedbackInquiry: {
          label: "Anfrage weiteres Vorgehen Bescheid",
        },
        dataLeakPersonalInvolvementInquiry: {
          label: "Anfrage persönliche Betroffenheit",
        },
        customerUpdatePoAInquiry: {
          label: "Anfrage neue Vollmacht",
        },
      },
    },
    decision: {
      label: "Entscheidung",
      question: {
        label: "Frage",
      },
      answer: {
        label: "Antwort",
        yes: {
          label: "Ja",
        },
        no: {
          label: "Nein",
        },
      },
    },
  },
};

export default historyItemTranslations;
